import React from "react";
import "./Home.styles.css";


const UsefulLinks = () => {
  return (
    <div className="list-group list_content">
      <a  href="https://simpleflying.com/category/aviation-news/" rel="noopener noreferrer" target="_blank" className="list-group-item list-group-item-action">
        simpleflying.com
      </a>
      <a href="https://www.flightglobal.com/news" rel="noopener noreferrer" target="_blank"className="list-group-item list-group-item-action">
        www.flightglobal.com
      </a>
      <a href="http://www.airports.ge/" rel="noopener noreferrer" target="_blank" className="list-group-item list-group-item-action">
       www.airports.ge
      </a>
     
    </div>
  );
};

export default UsefulLinks;
